import { render, staticRenderFns } from "./sales-record.vue?vue&type=template&id=34b02d22&scoped=true"
import script from "./sales-record.vue?vue&type=script&lang=ts"
export * from "./sales-record.vue?vue&type=script&lang=ts"
import style0 from "./sales-record.vue?vue&type=style&index=0&id=34b02d22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b02d22",
  null
  
)

export default component.exports